export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-brush/~/d3-color/src/math.js
// module id = 208
// module chunks = 0